<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $tc('messages.polls', 2),
                        href: meta.links.polls_index,
                    },
                    {
                        name: smileyPollQuestion.question,
                        href: meta.links.polls_show,
                    },
                    {
                        name: group.name,
                        href: meta.links.group_results_show,
                    },
                    {
                        name: smileyPollResult.date_display,
                        href: null,
                    },
                ]"
            />
        </template>

        <SmileyPoll :input-question="smileyPollQuestion.question" :input-results="smileyPollResult" />
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import SmileyPoll from '@/components/pageSpecific/SmileyPoll.vue';

export default {
    components: {
        SmileyPoll,
        PanelPage,
    },
    layout: Layout,
    name: 'Show',
    props: ['meta', 'smileyPollResult', 'smileyPollQuestion', 'group'],
};
</script>
